module.exports = __webpack_public_path__ + "static/media/count10Off_326.82c22211.png";